import { ReactNode } from 'react'
import { SelectOption } from '@pay-com/components'
import { isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js'
import { CountryFlag } from 'components/CountryFlag'

type Country = {
  name: string
  alpha2: string
}

export type CountryPhoneCodeOption = SelectOption & {
  selectedLabel: ReactNode
}

export const getCountryPhoneCodeOption = (
  country: Country
): CountryPhoneCodeOption | null => {
  if (!isSupportedCountry(country.alpha2)) return null

  const phoneCode = (() => {
    try {
      return getCountryCallingCode(country.alpha2)
    } catch {
      return null
    }
  })()

  if (!phoneCode) return null

  const labelText = `+${phoneCode}`

  return {
    value: country.alpha2,
    searchLabel: `${country.name} ${labelText}`,
    label: (
      <div className="flex items-center gap-1">
        <CountryFlag alpha2={country.alpha2} className="shrink-0" />
        <span>{country.name}</span>
        <span className="text-gray-500">{labelText}</span>
      </div>
    ),
    selectedLabel: (
      <div className="flex items-center gap-1">
        <CountryFlag alpha2={country.alpha2} />
        <span>{labelText}</span>
      </div>
    )
  }
}
